import React, { FC, useEffect, useState } from 'react';

// API
import apibridge from '../../apibridge';

// REDUX
import { useAppDispatch } from '../../store/slice';
import { ToastMessagesSlice } from '../../store/slice/ToastMessages';

// COMPONENTS
import TitleSection, { TitleSectionType } from '../../components/TitleSection/TitleSection';
import DelayedFadeIn from '../../components/_Helpers/DelayedFadeIn';
import { EmbeddedYouTubeOrVimeoVideo } from '../../components/_Helpers/Video';
import RichText from '../../components/RichText/RichText';

// UTILS
import { guid } from '../../libs/utils';

// PACKAGES
import { Spinner } from 'react-bootstrap';
import { PlannerHelpVideoHelpVideoInfo } from '../../api/models';

const HelpVideo: FC = () => {
	const dispatch = useAppDispatch();

	const [loading, setLoading] = useState(false);

	const titleSectionProps: TitleSectionType = {
		title: '',
		description: ''
	};

	// Get Planner Help Video Call set up
	const [helpVideoDetails, setHelpVideoDetails] = useState<PlannerHelpVideoHelpVideoInfo>({});

	const getPlannerHelpVideo = async () => {
		setLoading(true);

		const response = await apibridge.getPlannerHelpVideo();

		if (response && response.data) {
			if (!response.data.isError && response.data.result) {
				setHelpVideoDetails(response.data.result);
			} else if (response.data.validationErrors) {
				for (const err of response.data.validationErrors) {
					dispatch(
						ToastMessagesSlice.actions.add({
							id: guid(),
							type: 'danger',
							heading: 'Video Help error',
							description: err.reason || 'Unknown error'
						})
					);
				}
			}
		}

		setLoading(false);
	};

	useEffect(() => {
		getPlannerHelpVideo();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="class-details-page">
			<TitleSection {...titleSectionProps} backToText="Back to plans" backToUrl="/plans" title=""></TitleSection>

			<div className="container">
				<div className="help-video-wrapper">
					{loading ? (
						<div className="d-flex align-items-center justify-content-center">
							<DelayedFadeIn>
								<Spinner animation="border" role="status">
									<span className="visually-hidden">Loading...</span>
								</Spinner>
							</DelayedFadeIn>
						</div>
					) : (
						<>
							{helpVideoDetails.videoId ? (
								<>
									<EmbeddedYouTubeOrVimeoVideo youTubeOrVimeoId={helpVideoDetails?.videoId} />

									{helpVideoDetails.heading && (
										<h2 className="fw-bold mt-5 mb-4 text-shades-800">{helpVideoDetails.heading}</h2>
									)}

									{helpVideoDetails.description && <RichText content={{ markup: helpVideoDetails.description }} />}
								</>
							) : (
								<h2 className="fw-bold mt-5 mb-4 text-shades-800">There is no video</h2>
							)}
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default HelpVideo;
